var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconStatusRejected = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3333 1.34166L11.1583 0.166656L6.49996 4.82499L1.84163 0.166656L0.666626 1.34166L5.32496 5.99999L0.666626 10.6583L1.84163 11.8333L6.49996 7.17499L11.1583 11.8333L12.3333 10.6583L7.67496 5.99999L12.3333 1.34166Z",
    fill: "#DE3131"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconStatusRejected);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_status_rejected.d747f7b7711635cabf35518da2ffd1b4.svg";